/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DomainType,
  GridBinaryDataFormat,
  GridCreationParameters,
  GridHeader,
  GridIdAndName,
  GridMethod,
  ObjectNameInfo,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectGridClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Получение заголовков всех поверхностей в проекте.
   * @request GET:/geology/project/{projectId}/grid/all-headers
   * @secure
   */
  projectGridGetAllGridHeaders = (projectId: string, params: RequestParams = {}) =>
    this.http.request<GridHeader[], any>({
      path: `/geology/project/${projectId}/grid/all-headers`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Получение id всех поверхностей в проекте.
   * @request GET:/geology/project/{projectId}/grid/all-ids
   * @secure
   */
  projectGridGetAllGridIds = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/grid/all-ids`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Получение списка всех id и названий поверхностей в проекте.
   * @request GET:/geology/project/{projectId}/grid/all-idAndNames
   * @secure
   */
  projectGridGetGridIdNames = (projectId: string, params: RequestParams = {}) =>
    this.http.request<GridIdAndName[], any>({
      path: `/geology/project/${projectId}/grid/all-idAndNames`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Получение заголовка поверхности в проекте по идентификатору.
   * @request GET:/geology/project/{projectId}/grid/{gridId}
   * @secure
   */
  projectGridGetGridHeader = (projectId: string, gridId: string, params: RequestParams = {}) =>
    this.http.request<GridHeader, any>({
      path: `/geology/project/${projectId}/grid/${gridId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Получение заголовков поверхностей в проекте по идентификаторам.
   * @request POST:/geology/project/{projectId}/grid/headers
   * @secure
   */
  projectGridGetGridHeaders = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<GridHeader[], any>({
      path: `/geology/project/${projectId}/grid/headers`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectGrid
 * @summary Получить несжатый поток значений поверхности.
Значения записываются построчно, float.NaN - пропуск значения.
В заголовке записана геометрия.
 * @request GET:/geology/project/{projectId}/grid/{gridId}/nan-float-stream
 * @secure
 */
  projectGridGetGridNanFloatStream = (
    projectId: string,
    gridId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/geology/project/${projectId}/grid/${gridId}/nan-float-stream`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectGrid
 * @summary Получить сжатый gzip бинарный поток данных всей поверхности.
Значения записываются построчно.
В заголовке записана геометрия.
 * @request GET:/geology/project/{projectId}/grid/{gridId}/data/{binaryDataFormat}
 * @secure
 */
  projectGridGetGridBodyBinStream = (
    projectId: string,
    gridId: string,
    binaryDataFormat: GridBinaryDataFormat,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/geology/project/${projectId}/grid/${gridId}/data/${binaryDataFormat}`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Получение словаря пар id всех проектных и непроектных поверхностей.
   * @request GET:/geology/project/{projectId}/grid/idsMap
   * @secure
   */
  projectGridGetProjectGridIdMap = (projectId: string, params: RequestParams = {}) =>
    this.http.request<Record<string, string>, any>({
      path: `/geology/project/${projectId}/grid/idsMap`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectGrid
 * @summary Добавление поверхности в проект по полному набору параметров.
Вызывается с фронта при массовом импорте и при импорте из файла через GeoFileImport.
 * @request POST:/geology/project/{projectId}/grid
 * @secure
 */
  projectGridAddGridToProject = (
    projectId: string,
    data: GridCreationParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/geology/project/${projectId}/grid`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Добавление поверхности в проект потоком значений и набором параметров.
   * @request POST:/geology/project/{projectId}/grid/{rows}/{columns}/float-stream
   * @secure
   */
  projectGridAddGridStreamToProject = (
    projectId: string,
    rows: number,
    columns: number,
    data: {
      /** Наименование поверхности. */
      Name?: string
      /**
       * Тип поверхности в проекте.
       * @format int32
       */
      GridTypeId?: number
      /** Единица измерения. */
      MeasureUnit?: string
      /**
       * Координата начала сетки по оси Х.
       * @format double
       */
      OffsetX?: number
      /**
       * Координата начала сетки по оси Y.
       * @format double
       */
      OffsetY?: number
      /**
       * Шаг сетки по оси Х.
       * @format double
       */
      StepX?: number
      /**
       * Шаг сетки по оси Y.
       * @format double
       */
      StepY?: number
      /**
       * Угол поворота (CCW), градусы.
       * @format double
       */
      RotationAngle?: number
      /**
       * Х координата точки поворота.
       * @format double
       */
      RotationX?: number
      /**
       * Y координата точки поворота.
       * @format double
       */
      RotationY?: number
      /**
       * Значение в массиве данных, которое обозначает отсутствие данных в точке.
       * @format double
       */
      NullValue?: number
      /** Тип домена (Z - глубина в единицах расстояния, TWT - в единицах времени). */
      DomainType?: DomainType
      /** Метод, с помощью которого получена поверхность. */
      Method?: GridMethod
      /** Дополнительные данные о метода получения поверхности. */
      MethodMeta?: string
      /**
       * Несжатый поток значений float.
       * @format binary
       */
      file?: File
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/geology/project/${projectId}/grid/${rows}/${columns}/float-stream`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Добавит существующие поверхности в проект.
   * @request POST:/geology/project/{projectId}/grid/addExistingGrids
   * @secure
   */
  projectGridAddExistingGrids = (
    projectId: string,
    data: ObjectNameInfo[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/grid/addExistingGrids`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectGrid
 * @summary Удаление поверхностей из проекта по набору ключей.
Вернёт количество реально удалённых поверхностей.
 * @request PATCH:/geology/project/{projectId}/grid/remove
 * @secure
 */
  projectGridRemoveGridsFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/grid/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectGrid
   * @summary Переименовать поверхность в составе проекта.
   * @request PUT:/geology/project/{projectId}/grid/rename
   * @secure
   */
  projectGridRename = (projectId: string, data: ObjectNameInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/geology/project/${projectId}/grid/rename`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
